import React, {useState} from 'react';
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import {ErrorToast, SuccessToast} from "../../../shared/toasters/toasters";
import {ISubscriberAutoInformation} from "../interface";
import {Form} from "react-bootstrap";
import CreateForm from "./CreateForm";
import {AdminSubscriberAutoInformationService} from "../service";

const UpdateSubscriber = () => {
    const {t} = useTranslation();
    const navigate = useNavigate();
    const [state, setState] = useState<ISubscriberAutoInformation | null>(null);
    const submitHandler = () => {
        !!state?.id && AdminSubscriberAutoInformationService.update(state, state?.id)
            .then(() => {
                SuccessToast(t(`subscribers.successfully_updated`));
                navigate(-1);
                setState(null);
            })
            .catch((error) => ErrorToast(error));
    };

    return (
        <div className="col-12">
            <Form
                onSubmit={(e) => {
                    e.preventDefault();
                    submitHandler();
                }}
            >
                <CreateForm state={state} setState={setState}/>
            </Form>
        </div>
    );
};

export default UpdateSubscriber;